import React from "react";
import { certData } from "./CertificationsData.js";
import "./Certifications.css";

export default function Certifications() {
  return (
    <div className="certs-container">
      <h1 className="certs-heading">Certifications</h1>
      <div className="certs-list">
        {certData.map((cert, idx) => (
          <div className="cert-card" key={idx}>
            <h2 className="cert-title">{cert.title}</h2>
            <div className="cert-org">
              <span>Issued by:</span> {cert.issuedBy}
            </div>
            <p>
              <a 
                href={cert.certificationUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="cert-link"
              >
                View Credential
              </a>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
